import React,{ Component } from "react";
import { Field, reduxForm } from "redux-form";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, CardFooter } from "reactstrap";
import { renderField, renderCheckbox, password, required } from "../../../utils/formValidations.js";
import { getAdminUsers, getUsersId, updateUser } from "../../../actions/actionAdminUser";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import { withRouter } from "react-router-dom";
import Proptypes from "prop-types";


class UserFormTemplate extends Component  {
    constructor(props){
        super(props);
        this.state  = {
            currentUser: null
        };
        this.submitUser = this.submitUser.bind(this);
        this.cancelButton = this.cancelButton.bind(this);
        this.handleUpdateSuccess = this.handleUpdateSuccess.bind(this);
        this.handleCreateSuccess = this.handleCreateSuccess.bind(this);
    }

    handleUpdateSuccess(){
        const {errorUpdateMessage} = this.props;
        if(errorUpdateMessage){
            NotificationManager.error(errorUpdateMessage,"Update User", 3000);        
        }
        else {
            NotificationManager.success("User Update", "Successfully Updated User");
            this.props.history.push("/adminUser");
        }
    }

    handleUpdateError(){
        const {updateUsersError} = this.props;
        if(updateUsersError){
            NotificationManager.error(updateUsersError,"Update User", 3000);
        }
    }

    handleCreateSuccess(){
        const {createUsersError} = this.props;
        if(createUsersError){
            NotificationManager.error(createUsersError,"Create User", 3000);
        }
        else{
            NotificationManager.success("User Create", "Successfully Created User");
            this.props.history.push("/adminUser");
        }
    }

    handleCreateError(){
        const {createUsersError} = this.props;
        if(createUsersError){
            NotificationManager.warning(createUsersError,"Update User", 3000);
        }
    }

    submitUser(userData){
        if (this.props.fromUpdate){
            userData.user_id = this.props.userId;
            this.props.updateUser(userData).
                then(() => this.handleUpdateSuccess()).
                catch(() => this.handleUpdateError());
        } else {
            this.props.createUser(userData).
                then(() => this.handleCreateSuccess()).
                catch(() => this.handleCreateError());
        }
    }

    cancelButton(){
        this.props.history.push("/adminUser");
    }

    async componentDidMount(){
        if (this.props.fromUpdate){
            const data = await this.props.getAdminUserById(this.props.userId);

            const user = data.response.user;
            this.setState({ currentUser: user });

            this.props.initialize({
                username: user.username,
                first_name: user.first_name,
                last_name: user.last_name,
                locked: user.locked,
                disabled: user.disabled,
                notes: user.notes,
                realm: user.realm,
                organization: user.organization,
                phone: user.phone
            });
        }
    }

    render(){
        const {handleSubmit,fromUpdate} = this.props;
        const {currentUser} =  this.state;
        const checked = currentUser && currentUser.locked;
        const disabledChecked = currentUser && currentUser.disabled;
        const check = false;
        return (
            <Form onSubmit={handleSubmit(this.submitUser)}>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="username" className="requiredasterisk">User Name</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field 
                                    type="text"
                                    name="username" 
                                    id="username" 
                                    component={renderField} 
                                    validate={required}
                                /> 
                            </Col>
                        </Row>
                    </FormGroup>
                    {fromUpdate === true ?  
                        " " 
                        : 
                        <FormGroup>
                            <Row>
                                <Col sm="3">
                                    <Label htmlFor="password" className="requiredasterisk">Password</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field 
                                        type="password"
                                        name="password" 
                                        id="password" 
                                        component={renderField} 
                                        validate={[required, password]}
                                    /> 
                                </Col>
                            </Row>
                        </FormGroup>           
                    }
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="first_name">First Name</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="first_name" 
                                    id="first_name" 
                                    component={renderField}
                                />
                            </Col>
                        </Row> 
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="last_name">Last Name</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="last_name" 
                                    id="last_name" 
                                    component={renderField}
                                />
                            </Col>
                        </Row> 
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="realm">Realm</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="realm"
                                       id="realm"
                                       component={renderField}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="notes">Notes</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="notes" 
                                    id="notes" 
                                    component={renderField}
                                />
                            </Col>
                        </Row> 
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="locked" className="pull-left">Locked &nbsp;</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label check htmlFor="locked">            
                                    <Field name="locked" 
                                        id="locked" 
                                        type ="checkbox"
                                        checked = {checked}
                                        component={renderCheckbox}
                                    />
                                </Label>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="disabled" className="pull-left">Disabled &nbsp;</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label check htmlFor="disabled">
                                    <Field name="disabled"
                                        id="disabled"
                                        type ="checkbox"
                                        checked = {disabledChecked}
                                        component={renderCheckbox}
                                    />
                                </Label>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="5">
                                <label htmlFor="twoFactor" className="pull-left">Reset Two Factor Authentication Secret</label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label check htmlFor="twoFactor">
                                <Field name="set_two_factor"
                                       id="set_two_factor"
                                       type ="checkbox"
                                       check = {check}
                                       component={renderCheckbox}
                                />
                                </Label>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="organization">Organization</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="organization" 
                                    id="organization" 
                                    component={renderField}
                                /> 
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="phone">Phone</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field
                                    name="phone" 
                                    id="phone" 
                                    component={renderField} 
                                    placeholder="XXX-XXX-XXXX"
                                />
                            </Col>
                        </Row> 
                    </FormGroup>
                </CardBody>
                <CardFooter>
                    <FormGroup className="form-actions">
                      
                        <Button type="cancel" size="sm" className="cancel-button" color="basic" onClick={() => this.cancelButton()}>  Cancel</Button>
                        <Button type="submit" size="sm" className="submit-button" color="primary"> Submit</Button>
                    </FormGroup>
                </CardFooter>
            </Form>
        );
    }
}

UserFormTemplate.propTypes = {
    updateUser: Proptypes.func.isRequired,
    getAdminUsers: Proptypes.func.isRequired,
    getAdminUserById: Proptypes.func.isRequired,
    updatErrorWarning: Proptypes.func,
    updateUsersError: Proptypes.func,
    getUsersLoading: Proptypes.bool,
    errorUpdateMessage: Proptypes.func,
    createUserWarning: Proptypes.func,
    createUsersError: Proptypes.func,
    users: Proptypes.array,
    history: Proptypes.object.isRequired,
    handleSubmit: Proptypes.func,
    fromUpdate: Proptypes.bool, 
    userId: Proptypes.string,
    initialize: Proptypes.func,
    createUser: Proptypes.func
};



let UserFormWithRouter = withRouter(UserFormTemplate);

let UserForm =  connect(state => 
    ({
        users: state.admin.users || [],
        errorUpdateMessage: state.admin.errorUpdateMessage || null,
        updatErrorWarning: state.admin.updatErrorWarning || null,
        getUsersLoading: state.admin.getUsersLoading || false,
        updateUsersError: state.admin.updateUsersError || null,
        createUserWarning: state.admin.createUserWarning || null,
        createUsersError: state.admin.createUsersError || null
    }),
dispatch => 
    ({
        updateUser: (data) => dispatch(updateUser(data)),
        getAdminUsers: () => dispatch(getAdminUsers()),
        getAdminUserById: (id) => dispatch(getUsersId(id))
    }))(UserFormWithRouter);

export default reduxForm({
    form: "userForm",
    fields: ["first_name"], 
})(UserForm);